import contactForm from './contactForm';

const tradeForm = [
  {
    /*  */ type: 'card',
    collection: ['buyer'],
    subTitle: 'Tus Datos',
    card: [...contactForm],
  },
  {
    type: 'card',
    collection: ['seller'],
    subTitle: 'Datos del vendedor',
    card: [...contactForm],
  },
];

export default tradeForm;
